import React, { useEffect, useState } from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import ProgressBar from '@components/common/ProgressBar/ProgressBar';
import Text from '@components/common/Text/Text';
import { formatDateToWord, daysRemaining } from '@services/utils/DateService';
import { calculatePercentage } from '@services/utils/NumberService';

import css from './ObjectiveActivated.module.scss';

type ObjectiveActivatedProps = {
    collectedAmount: number;
    createdOn: string;
    dateLimit: string;
    amountToReach: number;
    isObjectiveCompleted: boolean;
};

const ObjectiveActivated = ({
    collectedAmount,
    dateLimit,
    amountToReach,
    isObjectiveCompleted,
}: ObjectiveActivatedProps) => {
    const { t } = useTranslateLpc(['lpc-pot']);

    const [percentage, setPercentage] = useState<number>(0);

    useEffect(() => {
        setPercentage(calculatePercentage(collectedAmount, amountToReach));
    }, [amountToReach, collectedAmount]);

    return (
        <>
            {(amountToReach > 0 || dateLimit) && (
                <div className={css.objective}>
                    <>
                        {amountToReach > 0 && (
                            <ProgressBar isObjectiveCompleted={isObjectiveCompleted} percentage={percentage} />
                        )}
                        {dateLimit && (
                            <div className={css.objective__amount}>
                                <Text variant={'caption_02'} color={'txt-primary'}>
                                    {t('amount.objective.finish-on')} {formatDateToWord(dateLimit)}
                                </Text>
                                <div className={css.objective__amount__days_remain}>
                                    <img src={'/front-static/icons/action/time-icon.svg'} alt="time" />
                                    <Text
                                        variant={'caption_02'}
                                        color={!isObjectiveCompleted ? 'ui-secondary' : 'ui-success'}
                                    >
                                        {daysRemaining(dateLimit) > 1
                                            ? t('amount.objective.day-left_plural', {
                                                  count: daysRemaining(dateLimit),
                                              })
                                            : t('amount.objective.day-left', { count: daysRemaining(dateLimit) })}
                                    </Text>
                                </div>
                            </div>
                        )}
                    </>
                    {isObjectiveCompleted && (
                        <div className={css.objective__tooltip}>
                            <Text
                                customClass={css.objective__tooltip__title}
                                variant={'caption_01'}
                                color={'txt-primary'}
                            >
                                <img src="/front-static/icons/display/info-outline.svg" alt="info" />
                                {t('amount.objective.tooltip-title')}
                            </Text>
                            <Text variant={'body_02'} color={'txt-primary'}>
                                {t('amount.objective.tooltip-desc')}
                            </Text>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};
export default ObjectiveActivated;
